import moment from 'moment';
import Queue from '@/models/Queue';
import Slot from '@/models/Slot';

export const parseQueue = (queue: Queue): Queue => {
    queue.slots.sort((a: Slot, b: Slot) => {
        const aStart : number = a.startDate as number;
        const bStart : number = b.startDate as number;
        return aStart - bStart;
    });

    queue.slots.map((slot: Slot) => {
        slot.startDate = moment.unix(+slot.startDate).format('YYYY-MM-DD HH:mm');
        slot.endDate = moment.unix(+slot.endDate).format('YYYY-MM-DD HH:mm');
        return slot;
    });


    if (queue.days) {
        queue.days.forEach((slotsGroup) => {
            slotsGroup.slots.sort((a: Slot, b: Slot) => {
                const aStart : number = a.startDate as number;
                const bStart : number = b.startDate as number;
                return aStart - bStart;
            });

            slotsGroup.slots.map((slot: Slot) => {
                slot.startDate = moment.unix(+slot.startDate).toDate();
                slot.endDate = moment.unix(+slot.endDate).toDate();
                return slot;
            });
        });
    }

    return queue;
};

